import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { BoardContainer } from "./BoardContainer";
import { BoardManager } from "./BoardManger";
import * as Mahjong from "@ravalmatic/mahjong-engine";
import { BoardScene } from "./BoardScene";
import { BoardClearedAnimation } from "./level-cleared-animation/BoardClearedAnimation";
import { AudioManager } from "../../AudioManager";

export class UndoContainer extends Phaser.GameObjects.Container {

    public static currentInstance: UndoContainer;
    
    public static TILE_SCALE = .44;
    public static TILE_A_POSITION_X = 23 - 20;
    public static TILE_B_POSITION_X = 23 + 20;
    public static TILE_POSITION_Y = -34;

    private tile1Img: Phaser.GameObjects.Image;
    private tile2Img: Phaser.GameObjects.Image;
    private undoBtn: Button;
    private currentTiles: {tile1: Mahjong.TileData, tile2: Mahjong.TileData};
    private matchFX: Phaser.GameObjects.Sprite;
   
    constructor(scene: Phaser.Scene) {

        super(scene);

        UndoContainer.currentInstance = this;

        this.x = GameConstants.GAME_WIDTH - 85 * GameVars.scaleX;
        this.y = GameConstants.GAME_HEIGHT;

        this.scaleX = GameVars.scaleX;

        this.matchFX = null;

        const background = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "undo_tab");
        background.setOrigin(.5, 1);
        this.add(background);

        this.undoBtn = new Button(this.scene, -52, -30, "texture_atlas_1", "btn_undo_off", "btn_undo_on");
        this.undoBtn.onDown(this.onClickUndo, this);
        this.add(this.undoBtn);

        if (!GameVars.gameData.data.savedActions.find((action: Mahjong.Action) => action.type === Mahjong.ActionType.TILES_SELECTED)) {
            this.undoBtn.disable();
        }
    }

    public startGame(): void {

        this.tile1Img = new Phaser.GameObjects.Image(this.scene, UndoContainer.TILE_A_POSITION_X, UndoContainer.TILE_POSITION_Y, "texture_atlas_1", "bamboo_1");
        this.tile1Img.setScale(UndoContainer.TILE_SCALE);
        this.tile1Img.setOrigin(BoardContainer.TILE_WIDTH / this.tile1Img.width, BoardContainer.TILE_HEIGHT / this.tile1Img.height);
        this.add(this.tile1Img);

        this.tile2Img = new Phaser.GameObjects.Image(this.scene, UndoContainer.TILE_B_POSITION_X, UndoContainer.TILE_POSITION_Y, "texture_atlas_1", "bamboo_1");
        this.tile2Img.setScale(UndoContainer.TILE_SCALE);
        this.tile2Img.setOrigin(BoardContainer.TILE_WIDTH / this.tile2Img.width, BoardContainer.TILE_HEIGHT / this.tile2Img.height);
        this.add(this.tile2Img);

        this.currentTiles = this.getTileTypes(GameVars.mahjongEngine.lastPair);

        if (GameVars.restoredSession && this.currentTiles) {
            this.tile1Img.setFrame(this.currentTiles.tile1.type);
            this.tile2Img.setFrame(this.currentTiles.tile2.type);
        } else {
            this.tile1Img.visible = false;
            this.tile2Img.visible = false;
        }

        if (!GameVars.levelReset) {

            this.y = GameConstants.GAME_HEIGHT + 125;

            this.scene.tweens.add({
                targets: this,
                y: GameConstants.GAME_HEIGHT,
                duration: 1000,
                delay: 3000,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }
    }

    public onMatch(): void {
          
        this.undoBtn.enable();

        this.currentTiles = this.getTileTypes(GameVars.mahjongEngine.lastPair);

        this.tile1Img.setFrame(this.currentTiles.tile1.type);
        this.tile2Img.setFrame(this.currentTiles.tile2.type);

        this.tile1Img.visible = true;
        this.tile2Img.visible = true; 

        if (GameVars.levelCleared) {

            this.undoBtn.disable();

            this.scene.time.delayedCall(100, () => {

                this.tile1Img.visible = false;  
                this.tile2Img.visible = false;

                BoardClearedAnimation.currentInstance.activate();
            }
            , [], this);
        }
    }

    public undo(): void {

        this.undoBtn.disable();

        // MOVER TILE AL BOARD CONTAINER
        this.tile1Img.x = this.tile1Img.x * this.scaleX + this.x;
        this.tile1Img.y += this.y;
        this.tile1Img.scaleX = UndoContainer.TILE_SCALE * this.scaleX;

        this.tile2Img.x = this.tile2Img.x * this.scaleX + this.x;
        this.tile2Img.y += this.y;
        this.tile2Img.scaleX = UndoContainer.TILE_SCALE * this.scaleX;
       
        BoardScene.currentInstance.add.existing(this.tile1Img);
        BoardScene.currentInstance.add.existing(this.tile2Img);

        // animarlas a su posicion original
        const offsetX = -4;
        let offsetY = -this.currentTiles.tile1.l * 12;

        const x1 = (this.currentTiles.tile1.p.c * BoardContainer.TILE_WIDTH + offsetX) * BoardContainer.currentInstance.scaleX + BoardContainer.currentInstance.x;
        const y1 = (this.currentTiles.tile1.p.r * BoardContainer.TILE_HEIGHT + offsetY) * BoardContainer.currentInstance.scaleY + BoardContainer.currentInstance.y;

        offsetY = -this.currentTiles.tile2.l * 12;

        const x2 = (this.currentTiles.tile2.p.c * BoardContainer.TILE_WIDTH + offsetX) * BoardContainer.currentInstance.scaleX + BoardContainer.currentInstance.x;
        const y2 = (this.currentTiles.tile2.p.r * BoardContainer.TILE_HEIGHT + offsetY) * BoardContainer.currentInstance.scaleY + BoardContainer.currentInstance.y;

        const duration = 500;

        const tile1Img = this.tile1Img;

        this.scene.tweens.add({
            targets: tile1Img,
            x: x1,
            y: y1,
            scaleX: BoardContainer.currentInstance.scaleX,
            scaleY: BoardContainer.currentInstance.scaleY,
            duration: duration,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {
                tile1Img.destroy();
            },
            onCompleteHandler: this
        });

        const tile2Img = this.tile2Img;

        this.scene.tweens.add({
            targets: tile2Img,
            x: x2,
            y: y2,
            scaleX: BoardContainer.currentInstance.scaleX,
            scaleY: BoardContainer.currentInstance.scaleY,
            duration: duration,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {
                tile2Img.destroy();

                if (GameVars.gameData.data.savedActions.find((action: Mahjong.Action) => action.type === Mahjong.ActionType.TILES_SELECTED)){
                    this.undoBtn.enable();
                }

                BoardContainer.currentInstance.onUndoTilesRestored();
            },
            onCompleteHandler: this
        });

        // instanciar nuevas
        this.tile1Img = new Phaser.GameObjects.Image(this.scene, UndoContainer.TILE_A_POSITION_X, UndoContainer.TILE_POSITION_Y, "texture_atlas_1", "bamboo_1");
        this.tile1Img.setScale(UndoContainer.TILE_SCALE);
        this.tile1Img.setOrigin(BoardContainer.TILE_WIDTH / this.tile1Img.width, BoardContainer.TILE_HEIGHT / this.tile1Img.height);
        this.add(this.tile1Img);

        this.tile2Img = new Phaser.GameObjects.Image(this.scene, UndoContainer.TILE_B_POSITION_X, UndoContainer.TILE_POSITION_Y, "texture_atlas_1", "bamboo_1");
        this.tile2Img.setScale(UndoContainer.TILE_SCALE);
        this.tile2Img.setOrigin(BoardContainer.TILE_WIDTH / this.tile2Img.width, BoardContainer.TILE_HEIGHT / this.tile2Img.height);
        this.add(this.tile2Img);

        // PUEDEN HABER HINTS EN LAS ACCIONES
        if (!GameVars.gameData.data.savedActions.find((action: Mahjong.Action) => action.type === Mahjong.ActionType.TILES_SELECTED)) {

            this.tile1Img.visible = false;
            this.tile2Img.visible = false;

        } else {

            this.currentTiles = this.getTileTypes(GameVars.mahjongEngine.lastPair);

            this.tile1Img.setFrame(this.currentTiles.tile1.type);
            this.tile2Img.setFrame(this.currentTiles.tile2.type);
        }

        AudioManager.playSound("pre_matched_pieces_fx");
    }

    public showMatchFX(): void {

        if (GameConstants.SHOW_SCORE) {

            // const x = (this.tile1Img.x + this.tile1Img.x) / 2 - 5;
            // const y = (this.tile1Img.y + this.tile1Img.y) / 2 - 4;
    
            // let comboLabel: Phaser.GameObjects.Text;
    
            // if (this.combo > 1) {
    
            //     comboLabel = new Phaser.GameObjects.Text(this.scene, x + 140, y, "X" + this.combo, {fontFamily: "OpenSans-CondLight", fontSize: "55px", color: "#FFF354"});
            //     comboLabel.setOrigin(.5);
            //     comboLabel.setShadow(2, 2, "#000000", 8);
            //     this.add(comboLabel);
    
            //     this.scene.time.delayedCall(650, function(): void {
            //         comboLabel?.destroy();
            //     }, [], this);
            // }
        }  
        
        if (!this.matchFX) {

            const tileA = BoardContainer.currentInstance.tileA;
            const tileB = BoardContainer.currentInstance.tileB;

            const x = (tileA.x + tileB.x) / 2 + 5; 
            const y = (tileA.y + tileA.y) / 2 - 4;

            this.matchFX = this.scene.add.sprite(x, y, "texture_atlas_4", "fx_match_00");
            this.matchFX.setScale(1.45);
            this.add(this.matchFX);
        
            this.matchFX.play("match_fx");
    
            // destruir el efecto cuando la animacion termino
            this.matchFX.on("animationcomplete", () => {
                this.matchFX.destroy();
                this.matchFX = null;
            }, this);
        }
    }

    private getTileTypes(pair: {tileA: Mahjong.TileData, tileB: Mahjong.TileData}): {tile1:  Mahjong.TileData, tile2:  Mahjong.TileData} {

        if (!pair) {
            return null;
        }

        let tile1: Mahjong.TileData;
        let tile2: Mahjong.TileData;

        if (pair.tileA.p.c === pair.tileB.p.c) {
            if (pair.tileA.p.r < pair.tileB.p.r) {
                tile1 = pair.tileA;
                tile2 = pair.tileB;
            } else {
                tile1 = pair.tileB;
                tile2 = pair.tileA; 
            }
        } else if (pair.tileA.p.c < pair.tileB.p.c) {
            tile1 = pair.tileA;
            tile2 = pair.tileB;
        } else {
            tile1 = pair.tileB;
            tile2 = pair.tileA; 
        }

        return {tile1, tile2};
    }

    private onClickUndo(): void {
        
        BoardManager.undo();
    }
}
